<script>
import { BSkeletonImg } from "bootstrap-vue";

export default {
  extends: BSkeletonImg
};
</script>